var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#00A4EA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.432 34.614c-.858 0-.713-.324-1.008-1.14L16.9 25.17l19.422-11.523",
  fill: "#C8DAEA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.434 34.614c.662 0 .954-.303 1.324-.662l3.531-3.434-4.405-2.656",
  fill: "#A9C9DD"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.882 27.863l10.673 7.886c1.218.672 2.097.324 2.4-1.13L38.3 14.144c.445-1.783-.68-2.592-1.845-2.063l-25.51 9.837c-1.742.698-1.732 1.67-.318 2.103l6.546 2.043 15.157-9.562c.715-.434 1.372-.2.833.278",
  fill: "url(#48_svg__paint0_linear_5493_83588)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "48_svg__paint0_linear_5493_83588",
  x1: 28.608,
  y1: 22.478,
  x2: 32.741,
  y2: 31.895,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFF7FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMjQiIGZpbGw9IiMwMEE0RUEiLz4KPHBhdGggZD0iTTIwLjQzMTYgMzQuNjE0MkMxOS41NzM1IDM0LjYxNDIgMTkuNzE5NCAzNC4yOTAyIDE5LjQyMzUgMzMuNDczMUwxNi45MDA0IDI1LjE2OTdMMzYuMzIyMiAxMy42NDc1IiBmaWxsPSIjQzhEQUVBIi8+CjxwYXRoIGQ9Ik0yMC40MzM2IDM0LjYxNEMyMS4wOTU3IDM0LjYxNCAyMS4zODgxIDM0LjMxMTIgMjEuNzU3OCAzMy45NTE5TDI1LjI4OSAzMC41MTgyTDIwLjg4NDMgMjcuODYyMSIgZmlsbD0iI0E5QzlERCIvPgo8cGF0aCBkPSJNMjAuODgyMiAyNy44NjM0TDMxLjU1NTMgMzUuNzQ4OUMzMi43NzM0IDM2LjQyMDkgMzMuNjUyMiAzNi4wNzI5IDMzLjk1NTcgMzQuNjE4MkwzOC4zMDAyIDE0LjE0NTNDMzguNzQ0OSAxMi4zNjIgMzcuNjIwNCAxMS41NTI5IDM2LjQ1NTEgMTIuMDgxOUwxMC45NDQyIDIxLjkxODhDOS4yMDI4NiAyMi42MTczIDkuMjEzMjMgMjMuNTg4OSAxMC42MjY4IDI0LjAyMTdMMTcuMTczNSAyNi4wNjUxTDMyLjMyOTggMTYuNTAzMkMzMy4wNDUzIDE2LjA2OTMgMzMuNzAyMSAxNi4zMDI0IDMzLjE2MzIgMTYuNzgwOSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzU0OTNfODM1ODgpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNTQ5M184MzU4OCIgeDE9IjI4LjYwNzYiIHkxPSIyMi40NzgyIiB4Mj0iMzIuNzQwOCIgeTI9IjMxLjg5NTMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0VGRjdGQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { Svg48 as ReactComponent };